<template>
  <div class="userList-box">
    <!--操作栏-->
    <div class="action-bar">
      <!-- <el-input
        placeholder="请输入热搜词"
        clearable
        v-model="searchParam.keyWord"
        size="small"
        @keyup.enter.native="refreshSearch"
        class="param-input"
      ></el-input> -->
      <!-- <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker> -->
      <el-button type="primary" size="small" @click="refreshSearch"
        >搜索</el-button
      >
      <el-button type="primary" size="small" @click="add">新增</el-button>
      <el-button type="primary" size="small" @click="batchShield(idList)"
        >批量删除</el-button
      >
    </div>
    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="520"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        align="center"
        fixed
        disabled="true"
        :selectable="selectable"
        :reserve-selection="true"
      ></el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        min-width="210"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="districtCode"
        label="热搜词"
        align="center"
        fixed
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.word || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Sort"
        label="排序"
        align="center"
        fixed
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="registerIP"
        label="状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">启用</span>
          <span v-else>禁用</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        min-width="160"
      >
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 20, 30]"
      :current-page="searchParam.pageNumber"
      :page-size="searchParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="wordDialogVisible"
      width="440px"
      @close="close"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="80px">
        <el-form-item label="热搜词:" prop="word">
          <el-input v-model="params.word" size="small"></el-input>
        </el-form-item>
        <el-form-item label="排序:" prop="sort">
          <el-input v-model.number="params.sort" size="small"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="params.status" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in statusArr"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="wordDialogVisible = false" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="confirm" :loading="flag" size="small"
          >确 认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
import API from "@/api";
import { sortEscape } from "@/utils/global";
export default {
  data() {
    return {
      action: baseConfig.baseServerUrl + "/agent/upload/static",
      dialogFormVisible: false,
      banTableData: [],
      uid: "",
      auth: true,
      banTotal: "",
      banLoading: false,
      form: {
        phone: "",
      },
      imgUrl: baseConfig.imgUrl,
      rules: {
        word: [{ required: true, message: "请输入热搜词", trigger: "blur" }],
      },
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      // 封禁理由列表参数
      dialogTitle: "添加热搜词",
      params: {
        status: 1,
        sort: undefined,
        id: undefined,
        word: "",
      },
      statusArr: [
        {
          label: "启用",
          value: 1,
        },
        {
          label: "禁用",
          value: 0,
        },
      ],
      // 用户管理列表请求参数
      searchParam: {
        pageNumber: 1,
        pageSize: 10,
        // keyword: "",
        // start: "",
        // end: "",
      },
      // 批量选择内容ID
      idList: [],
      wordDialogVisible: false,
      flag: false,
    };
  },
  created() {
    this.auth = true;
    this.getList(this.searchParam);
    // this.queryVipCard();
    // this.auth = validatorAuthority();
    // this.getUserList(this.searchParam);
  },
  methods: {
    getRowKeys(row) {
      return row.ID;
    },
    // 禁止选择勾选框
    selectable(row) {
      if (row.isDelete) {
        return false;
      } else {
        return true;
      }
    },
    add() {
      this.dialogTitle = "新增热搜词";
      this.wordDialogVisible = true;
    },
    edit(row) {
      this.dialogTitle = "编辑热搜词";
      this.params.id = row.id;
      this.params.sort = row.sort;
      this.params.status = row.status;
      this.params.word = row.word;
      this.wordDialogVisible = true;
    },

    // 获取批量操作数据id
    handleSelectionChange(row) {
      console.log(row);
      var arr = [];
      row.forEach(function(item) {
        arr.push(item.ID);
      });
      this.idList = arr;
    },
    // 批量删除
    batchShield(idList) {
      if (idList.length === 0) {
        this.$message.error("至少选择一条数据进行操作");
        return false;
      }

      this.remove(idList);
    },

    // 删除聊天内容
    remove(idList) {
      this.$confirm("您确定要删除当前热搜词？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.delHotSearchWord({ ids: idList }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除内容成功",
                type: "success",
              });
              this.getList(this.searchParam);
            } else {
              this.$message.error("删除内容失败");
            }
          });
        })
        .catch(() => {});
    },

    // 时间选择回掉
    // changeTime(time) {
    //   if (time) {
    //     this.searchParam.start = changeTime(time[0]);
    //     this.searchParam.end = changeTime(time[1]);
    //   } else {
    //     this.searchParam.startTime = "";
    //     this.searchParam.endTime = "";
    //   }
    //   this.refreshSearch();
    // },
    // 搜索对应列表
    refreshSearch() {
      this.searchParam.pageNumber = 1;
      this.getList(this.searchParam);
    },
    // 搜索对应列表
    search() {
      this.getList(this.searchParam);
    },
    // 请求用户列表
    getList(obj) {
      this.loading = true;
      API.getHotSearch(obj)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 数据排序
    handleSortChange(column) {
      this.searchParam.value = sortEscape(column.order);
      this.searchParam.key = column.prop;
      this.getList(this.searchParam);
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.searchParam.pageSize = size;
      this.searchParam.pageNumber = 1;
      this.getList(this.searchParam);
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.searchParam.pageNumber = pageNumber;
      this.getList(this.searchParam);
    },
    // 编辑用户
    editUser(row) {
      this.$refs.editUser.open(row);
    },
    bindVipClose() {
      this.bindVipCard = "";
      this.bindUid = "";
    },
    confirm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.dialogTitle === "新增热搜词") {
            this.addWord();
          } else {
            this.editWord();
          }
        } else {
          return false;
        }
      });
    },
    async addWord() {
      let params = Object.assign({}, this.params);
      API.addHotSearchWord(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            this.getList(this.searchParam);
          } else {
            this.$message.error("新增失败");
          }
          this.flag = false;
          this.wordDialogVisible = false;
        })
        .catch(() => {
          this.flag = false;
          this.wordDialogVisible = false;
        });
    },
    async editWord() {
      let params = Object.assign({}, this.params);
      API.editHotSearchWord(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success",
            });
            this.getList(this.searchParam);
          } else {
            this.$message.error("编辑失败");
          }
          this.flag = false;
          this.wordDialogVisible = false;
        })
        .catch(() => {
          this.flag = false;
          this.wordDialogVisible = false;
        });
    },
    close() {
      this.params.id = undefined;
      this.params.word = "";
      this.params.sort = undefined;
      this.params.status = 1;
    },
  },
};
</script>
<style lang="scss">
.el-message-box {
  .cancel_right {
    float: right;
    margin-left: 10px;
  }
}
</style>
<style scoped lang="scss">
.userList-box {
  .v-number {
    vertical-align: middle;
  }
  .view-details {
    margin-left: 10px;
    color: #e63765;
    font-size: 18px;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      color: #eb5f84;
    }
  }
  /deep/.col_layout {
    /deep/ div {
      display: flex;
      justify-content: center;
      padding-left: 50px;
      button {
        margin-left: auto;
      }
    }
  }
}
.form_item {
  display: flex;
  align-items: center;
  justify-content: center;
  .form_item_name {
    margin-right: 20px;
  }
}
/deep/ .desc {
  display: none;
}
/deep/ .el-form-item {
  display: flex;
}
/deep/ .el-form-item__content {
  width: 400px;
}
/deep/ .el-select {
  width: 100%;
}
</style>
